import { Injectable } from '@angular/core';
import { FieldDictionaryDto, pageFields } from '../../models/base/base';
import { FieldsConfigService } from './fields-config.service';
import { BehaviorSubject, Subject, takeUntil } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class FieldDictionaryListService {
  list: pageFields[] = [];
  public listSubject = new BehaviorSubject<pageFields[]>([]);
  currentlang: string;
  tablename: string;
  systemmenuid: string

  private destroy$: Subject<void> = new Subject<void>();

  private filterColumnsSubject = new BehaviorSubject<FieldDictionaryDto[] | any>(null);
  filterColumns = this.filterColumnsSubject.asObservable();

  constructor(
    private fieldsConfigService: FieldsConfigService<FieldDictionaryDto>,

  ) {
    this.getFilterColumns();
  }

  getPageFields(pageid) {
    this.fieldsConfigService.getPageData(pageid).pipe(takeUntil(this.destroy$)).subscribe({
      next: (res) => {
        console.log(res)
        const exist = this.list.find((el) => el.pageid === pageid);
        const existIndex = this.list.findIndex((el) => el.pageid === pageid);
        let list = {
          pageid: pageid,
          list: res.result
        };
        if (exist) {
          this.list[existIndex] = { pageid: pageid, list: list.list };
        } else {
          this.list.push({ pageid: pageid, list: list.list });
          this.listSubject.next(this.list);
        }
      }
    });
  }

  getList() {
    return this.listSubject.asObservable();
  }

  setData(tablename, menuid) {
    this.tablename = tablename
    this.systemmenuid = menuid
  }

  getFilterColumns() {
    this.getList().pipe(takeUntil(this.destroy$)).subscribe({
      next: (res: any) => {
        const pageData = res.find((x) => x.pageid == this.systemmenuid);
        if (!pageData) return
        const filterListFields = pageData.list.filter((el) => this.tablename ? el.filter && el.tablename == this.tablename : el.filter);
        this.filterColumnsSubject.next(filterListFields);
      }
    })
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
